import axios from "axios";
import moment from "moment";
import { formatTwitterInsightsData, getAccessToken, getLiteCompanyId, getUserId } from "./utils.js";
import { getUrl } from "./urls";
import { toast } from "react-toastify";
import { formatPageList } from "./twitterInsightsActionUtils.js";

export const TWITTER_INSIGHTS_AUTHENTICATE = "TWITTER_INSIGHTS_AUTHENTICATE";
export const FETCH_TWITTER_INSIGHTS_OAUTH_TOKEN = "FETCH_TWITTER_INSIGHTS_OAUTH_TOKEN";
export const SET_TWITTER_SELECTED_PAGE = "SET_TWITTER_SELECTED_PAGE";
export const UPDATE_TWITTER_DURATION_FILTER = "UPDATE_TWITTER_DURATION_FILTER";
export const FETCH_TWITTER_PAGE_LIST = "FETCH_TWITTER_PAGE_LIST";
export const FETCH_TWITTER_CHART_DATA = "FETCH_TWITTER_CHART_DATA";

export function fetchTwitterInsightsoAuthToken() {
    let res = axios({
        method: "GET",
        url: getUrl("twitter_insights_oauth_token"),
        headers: {
            "Content-Type": "application/json",
            cache: false,
        },
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err;
        });
    return {
        type: "FETCH_TWITTER_INSIGHTS_OAUTH_TOKEN",
        payload: res,
    };
}

export function twitterInsightsAuthenticate(params) {
    let res = axios({
        method: "POST",
        url: getUrl("twitter_insights_authenticate"),
        headers: {
            "Content-Type": "application/json",
            cache: false,
        },
        data: params,
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err;
        });
    return {
        type: "TWITTER_INSIGHTS_AUTHENTICATE",
        payload: res,
    };
}

export function fetchPageList() {
    let res = axios({
        method: "GET",
        url: getUrl("social_token_list"),
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            return formatPageList(res.data.data.tokens.filter((page) => page.platform === "twitter" && page.insight_feature === 1));
        })
        .catch((err) => {
            toast.error(err.response?.data?.message);
            return err;
        });
    return {
        type: "FETCH_TWITTER_PAGE_LIST",
        payload: res,
    };
}

export function setSelectedPage(value) {
    return {
        type: "SET_TWITTER_SELECTED_PAGE",
        payload: value,
    };
}

export function updateDurationFilter(value) {
    return {
        type: "UPDATE_TWITTER_DURATION_FILTER",
        payload: value,
    };
}

export const getPrevAndPresentTwitterInsightsData = (args) => {
    return (dispatch) => {
        const { filter, key, selectedTwitterPage } = args;
        let chartName = key;
        dispatch({ type: "FETCH_TWITTER_CHART_DATA_PENDING", key: chartName });

        let metrics = key.split("-")[0] + ",recent_posts_count";
        const ApiCall = (start_date, end_date) => {
            let url = `${getUrl("twitterInsights")}?page_id=${
                selectedTwitterPage?.value
            }&end_date=${end_date}&start_date=${start_date}&metrics=${metrics}&agreegate_interval=yearly`;
            return url;
        };

        let presentDurationData = axios
            .get(ApiCall(filter.start_date, filter.end_date), {
                headers: {
                    "Content-type": "application/json",
                    "access-token": getAccessToken(),
                },
            })
            .then((res) =>
                // { return res}
                ({ name: "presentDurationData", data: res.data }),
            )
            .catch((err) => {
                console.log("err fetching presentDurationData", err);
                dispatch({ type: "FETCH_TWITTER_CHART_DATA_REJECTED", key, payload: err });
            });

        let durationGap = moment(filter.end_date).diff(moment(filter.start_date), "days", true);

        const prevDataStartDate = moment(filter.start_date)
            .subtract(durationGap + 1, "days")
            .startOf("day")
            .format("YYYY-MM-DD");
        const prevDataEndDate = moment(filter.start_date).subtract(1, "day").format("YYYY-MM-DD");

        let prevDurationData = axios
            .get(ApiCall(prevDataStartDate, prevDataEndDate), {
                headers: {
                    "Content-type": "application/json",
                    "access-token": getAccessToken(),
                },
            })
            .then((res) => ({ name: "previousDurationData", data: res.data }));

        Promise.all([presentDurationData, prevDurationData])
            .then((response) => {
                dispatch({
                    type: "FETCH_TWITTER_CHART_DATA_FULFILLED",
                    key,
                    payload: formatTwitterInsightsData(response, filter.start_date, filter.end_date, key, chartName),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_TWITTER_CHART_DATA_REJECTED", key, payload: err });
                return err;
            });
    };
};
export const getTwitterInsightsData = (arg) => {
    return (dispatch) => {
        const { filter, key, selectedTwitterPage, getTotalPosts } = arg;
        dispatch({ type: "FETCH_TWITTER_CHART_DATA_PENDING", key });

        let metrics = key.split("-")[0];
        if (getTotalPosts) metrics = metrics + ",recent_posts_count" + ",page_promoted_impression_overtime";

        if (metrics === "page_engagement_rate") metrics = "follower_growth_overtime,page_engagement_overtime";

        let url = `${getUrl("twitterInsights")}?page_id=${selectedTwitterPage?.value}&end_date=${filter.end_date}&start_date=${
            filter.start_date
        }&metrics=${metrics}&agreegate_interval=${filter.aggs_val}`;

        axios
            .get(url, {
                headers: {
                    "Content-type": "application/json",
                    "access-token": getAccessToken(),
                },
            })
            .then((res) => {
                dispatch({
                    type: "FETCH_TWITTER_CHART_DATA_FULFILLED",
                    key,
                    payload: formatTwitterInsightsData(res.data, filter.start_date, filter.end_date, key),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_TWITTER_CHART_DATA_REJECTED", key, payload: err });
                return err;
            });
    };
};

const getPreviousTotalData = async (filter, key, selectedTwitterPage) => {
    const startDate = moment(new Date(filter.start_date).toLocaleDateString());
    const endDate = moment(new Date(filter.end_date).toLocaleDateString());

    const duration = moment.duration({ days: endDate.diff(startDate, "days") }) + 1;

    const newStartDate = moment(startDate.subtract(duration)._d).format();

    const newData = JSON.parse(JSON.stringify(filter));
    newData.start_date = newStartDate;
    newData.end_date = filter.start_date;

    let url = `${getUrl("twitterInsights")}?page_id=${selectedTwitterPage?.value}&end_date=${newData.end_date}&start_date=${newData.start_date}&metrics=${
        key.split("-")[0]
    }`;

    return await axios
        .get(url, {
            headers: {
                "Content-type": "application/json",
                "access-token": getAccessToken(),
            },
        })
        .then((res) => {
            return res;
        })
        .catch((err) => {
            console.log(err);
        });
};

export const getTotalValuesData = (arg) => {
    return (dispatch) => {
        const { filter, key, selectedTwitterPage } = arg;

        const previousDataPromise = getPreviousTotalData(filter, key, selectedTwitterPage);

        dispatch({ type: "FETCH_TWITTER_CHART_DATA_PENDING", key });
        let url = `${getUrl("twitterInsights")}?page_id=${selectedTwitterPage?.value}&end_date=${filter.end_date}&start_date=${filter.start_date}&metrics=${
            key.split("-")[0]
        }`;

        const currentDataPromise = axios.get(url, {
            headers: {
                "Content-type": "application/json",
                "access-token": getAccessToken(),
            },
        });

        const allPromise = Promise.all([previousDataPromise, currentDataPromise]);
        allPromise
            .then((res) => {
                dispatch({
                    type: "FETCH_TWITTER_CHART_DATA_FULFILLED",
                    key,
                    payload: formatTwitterInsightsData(res, filter.start_date, filter.end_date, key),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_TWITTER_CHART_DATA_REJECTED", key, payload: err });
                return err;
            });
    };
};

export const getAverageLikesOverTime = (arg) => {
    return (dispatch) => {
        const { filter, key, selectedTwitterPage } = arg;

        dispatch({ type: "FETCH_TWITTER_CHART_DATA_PENDING", key });
        let url = `${getUrl("twitterInsights")}?page_id=${selectedTwitterPage?.value}&end_date=${filter.end_date}&start_date=${filter.start_date}&metrics=${
            key.split("-")[0]
        }&agreegate_interval=${filter.aggs_val}`;
        axios
            .get(url, {
                headers: {
                    "Content-type": "application/json",
                    "access-token": getAccessToken(),
                },
            })
            .then((res) => {
                const countData = res.data;

                let url = `${getUrl("twitterInsights")}?page_id=${selectedTwitterPage?.value}&end_date=${filter.end_date}&start_date=${
                    filter.start_date
                }&metrics=tweet_overtime&agreegate_interval=${filter.aggs_val}`;
                axios
                    .get(url, {
                        headers: {
                            "Content-type": "application/json",
                            "access-token": getAccessToken(),
                        },
                    })
                    .then((response) => {
                        dispatch({
                            type: "FETCH_TWITTER_CHART_DATA_FULFILLED",
                            key,
                            payload: formatTwitterInsightsData(
                                { postData: response.data, countData },
                                filter.start_date,
                                filter.end_date,
                                "averageLikesOverTime",
                            ),
                        });
                    })
                    .catch((error) => {
                        console.log(error);
                        dispatch({ type: "FETCH_TWITTER_CHART_DATA_REJECTED", key, payload: error });
                        return error;
                    });
            })
            .catch((err) => {
                console.log(err);
            });
    };
};
